import { Slide } from "@jelly/lesson";
import config from "appConfig";
import variables from "../../../../../../assets/styles/sass-resources.scss";

import { task as task02 } from "../../../../../task/course-03/lesson-02/task-02";

const task: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "1:0": 2,
      },
      colsSize: [2.5, 1],
      rowsSize: [1, 3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "A Mass-Spring system with parameters M=1 kg, K=100 N/m and ξ =0.1 is submitted to a Dirac exctitation at<br>time t=0. What is the shape of its impulse response ",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    textAlign: "center",
                    color: variables["text-secondary"],
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/02/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
